import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Badge } from '../ui/badge';
import { API, adminHeaders } from '../../lib/shop';

const COLORS = { new: 'bg-green-500', confirmed: 'bg-blue-500', completed: 'bg-gray-700', cancelled: 'bg-red-400' };

export const AdminSurveys = () => {
  const [surveys, setSurveys] = useState([]);

  const load = () => axios.get(`${API}/surveys/all`, { headers: adminHeaders() }).then(r => setSurveys(r.data)).catch(() => toast.error('Failed to load surveys'));
  useEffect(() => { load(); }, []);

  const setStatus = async (s, status) => {
    try {
      await axios.patch(`${API}/surveys/${s.id}/status?status=${status}`, null, { headers: adminHeaders() });
      toast.success(`Survey marked ${status}`);
      load();
    } catch { toast.error('Update failed'); }
  };

  if (surveys.length === 0) return <p className="text-gray-600" data-testid="admin-surveys-empty">No home survey bookings yet.</p>;

  return (
    <div className="space-y-4" data-testid="admin-surveys">
      {surveys.map(s => (
        <div key={s.id} className="bg-white rounded-xl border border-gray-200 p-4" data-testid={`admin-survey-${s.id.slice(0, 8)}`}>
          <div className="flex flex-wrap justify-between items-start gap-3">
            <div>
              <p className="font-bold text-gray-900">{s.name} <span className="text-gray-400 font-normal text-sm ml-2">Ref {s.id.slice(0, 8).toUpperCase()}</span></p>
              <p className="text-sm text-gray-700 mt-1"><strong>Visit:</strong> {new Date(s.preferred_date).toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' })} · {s.time_slot_label}</p>
              <p className="text-sm text-gray-600">{s.address}</p>
              <p className="text-sm text-gray-600"><a href={`tel:${s.phone}`} className="hover:text-pink-600">{s.phone}</a> · <a href={`mailto:${s.email}`} className="hover:text-pink-600">{s.email}</a></p>
              {s.notes && <p className="text-sm text-gray-500 italic mt-1">“{s.notes}”</p>}
            </div>
            <div className="text-right">
              <Badge className={`${COLORS[s.status] || 'bg-gray-500'} text-white`}>{s.status.toUpperCase()}</Badge>
              <p className="text-xs text-gray-400 mt-1">Requested {new Date(s.created_at).toLocaleDateString('en-GB')}</p>
            </div>
          </div>
          {s.notification && (
            <p className="text-xs mt-2">
              {s.notification.business_sent ? <span className="text-green-600">Email notification sent</span>
                : s.notification.pending ? <span className="text-gray-500">Email sending...</span>
                : <span className="text-amber-600">Email not sent: {s.notification.error}</span>}
            </p>
          )}
          <div className="flex flex-wrap gap-2 mt-3">
            <a href={`tel:${s.phone}`} className="text-sm px-3 py-1 rounded-full bg-pink-50 text-pink-700 hover:bg-pink-100">Call</a>
            <a href={`https://wa.me/${s.phone.replace(/[^\d]/g, '').replace(/^0/, '44')}`} target="_blank" rel="noopener noreferrer" className="text-sm px-3 py-1 rounded-full bg-green-50 text-green-700 hover:bg-green-100">WhatsApp</a>
            {s.status === 'new' && <button onClick={() => setStatus(s, 'confirmed')} className="text-sm px-3 py-1 rounded-full bg-blue-50 text-blue-700 hover:bg-blue-100" data-testid={`survey-confirm-${s.id.slice(0, 8)}`}>Mark confirmed</button>}
            {s.status === 'confirmed' && <button onClick={() => setStatus(s, 'completed')} className="text-sm px-3 py-1 rounded-full bg-gray-100 text-gray-700 hover:bg-gray-200">Mark completed</button>}
            {s.status !== 'cancelled' && s.status !== 'completed' && <button onClick={() => setStatus(s, 'cancelled')} className="text-sm px-3 py-1 rounded-full text-red-600 hover:bg-red-50">Cancel</button>}
          </div>
        </div>
      ))}
    </div>
  );
};
